import { getTranslationFallback } from '../../utils/translation.utils';
import ProductFilterSlider from './product-filter-slider.model';
import { IProductFilterDTO, ProductFilterTypes } from './product-filter-base.model';

export default class ProductFilterPriceSlider extends ProductFilterSlider {
  step = 1;
  type = ProductFilterTypes.PriceSlider;

  static create(data: IProductFilterDTO): ProductFilterPriceSlider {
    return Object.assign(new ProductFilterPriceSlider(), data, {
      name: getTranslationFallback(`dcp.search.facet.${data.code}`, data.displayName ?? data.name),
      max: data.max ?? 1,
      min: data.min ?? 0,
      minFormatted: data.minFormatted ?? 0,
      maxFormatted: data.maxFormatted ?? 1,
      fromFormatted: data.fromFormatted ?? data.minFormatted ?? 0,
      toFormatted: data.toFormatted ?? data.maxFormatted ?? 1,
      step: data.step ?? 1,
      label: getTranslationFallback(
        `dcp.search.facetCode.${data.code}.${data.facetDisplayType}`,
        data.values?.[0]?.name ?? 'from {from} to {to}',
      ),
      value: data.value ?? [data.from ?? data.min ?? 0, data.to ?? data.max ?? 1],
    } as Partial<ProductFilterPriceSlider>);
  }

  clone() {
    return ProductFilterPriceSlider.create(this);
  }

  getFromFormattedValue(): string | number {
    return this.isMaxSlider() ? this.min : this.fromFormatted;
  }

  getToFormattedValue(): string | number {
    return this.isMaxSlider() ? this.value[0] : this.toFormatted;
  }
}
